import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const Break = lazy(()=> import(/* webpackChunkName: "Break" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/break" component={Break} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Break/routes.js